import {customElement, html, LitElement, property, PropertyValues} from 'lit-element';
import './scss/header-nav.scss';
import Mmenu from '../node_modules/mmenu-js/dist/core/oncanvas/mmenu.oncanvas';
import offcanvas from '../node_modules/mmenu-js/dist/core/offcanvas/mmenu.offcanvas';
import screenReader from '../node_modules/mmenu-js/dist/core/screenreader/mmenu.screenreader';
import scrollBugFix from '../node_modules/mmenu-js/dist/core/scrollbugfix/mmenu.scrollbugfix';
import counters from '../node_modules/mmenu-js/dist/addons/counters/mmenu.counters';
import navbars from '../node_modules/mmenu-js/dist/addons/navbars/mmenu.navbars';
import searchfield from '../node_modules/mmenu-js/dist/addons/searchfield/mmenu.searchfield';
import {SecurityInterceptor} from './security-interceptor';
import jwtDecode, {JwtPayload} from 'jwt-decode';
import axiosRetry from 'axios-retry';
// @ts-ignore
import logoImage from './images/awi_logo_transparent.png';
const autocompleteTypeahead = require('autocompleter');
require('../node_modules/mmenu-js/dist/mmenu.css');
require('../node_modules/mmenu-js/dist/mmenu.polyfills.js');
const axios = require('axios').default;
axiosRetry(axios, {
  retries: 2,
  retryDelay: (retryCount) => {
    return retryCount * 200;
  },
  // @ts-ignore
  retryCondition: (error) => {
    return [400, 404, 408, 425, 500, 502, 503, 504].find((e) => e === error.response.status);
  }
});

function itemLabel(link) {
  return link.navigationProperties && link.navigationProperties.navLabel ? link.navigationProperties.navLabel : link.title;
}

function fixRelativeLinks(link) {
  return link && link.assetLink.includes('http') || link && link.assetLink.includes('https') ? link && link.assetLink : link && link.assetLink.startsWith('/') ? link && link.assetLink : '/' + link.assetLink;
}

function isRemoteUrl(url) {
  return (/(http(s?)):\/\//i.test(url));
}

function detectTarget(url) {
  let target = '_self';
  const origin = new URL(location.origin);
  const originHost = origin.hostname.split('.');
  if (originHost.length > 1) {
    originHost.shift();
  }
  const hostDomain = originHost.join('.');
  let link;
  if (url && url.assetLink && isRemoteUrl(url.assetLink)) {
    link = new URL(url.assetLink);
    const linkHost = link.hostname.split('.');
    if (linkHost.length > 1) {
      linkHost.shift();
    }
    const linkDomain = linkHost.join('.');
    if (linkDomain !== hostDomain) {
      target = '_blank';
    }
  }
  return target;
}

function splitToChunks(array, parts) {
  let result: any[];
  result = new Array(Math.ceil(array.length / parts))
    .fill('')
    .map((_) => array.splice(0, parts));
  return result;
}

function getCookie(name) {
  const cookie = {};
  document.cookie.split(';').forEach((el) => {
    const [k, v] = el.split('=');
    cookie[k.trim()] = v;
  });
  return cookie[name];
}

function setCookie(key: string, value: string): void {
  const hostname = window.location.hostname.split('.');
  if (hostname.length > 1) {
    hostname.shift();
  }
  document.cookie = `${key}=${value}` + '; path=/; expires=session; SameSite=Lax; domain=' + hostname.join('.');
}

function deleteAllCookies(callback) {
  const promises = [];
  const cookies = document.cookie.split(';');
  // tslint:disable-next-line:prefer-for-of
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=' + window.location.hostname + '; path=/';
    // for subdomains
    const hostParts = window.location.hostname.split('.');
    if (hostParts.length > 2) {
      hostParts.shift();
      const newHost = '.' + hostParts.join('.');
      document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=' +  newHost + '; path=/';
    }
    promises.push(i);
  }

  Promise.all(promises).then((res) => {
    callback(res);
  });
}

function getObjectCookie(name: string) {
  const cookieName = name + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieArray = decodedCookie.split(';');
  // tslint:disable-next-line:prefer-for-of
  for (let i = 0; i < cookieArray.length; i++) {
    let cookie = cookieArray[i];
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(cookieName) === 0) {
      const value = cookie.substring(cookieName.length, cookie.length);
      try {
        return JSON.parse(value);
      } catch (e) {
        return null;
      }
    }
  }
  return null;
}

// check logged in user roles
function getMultipleIndexes(items: any, array: any[]) {
  // should ideally be a comma delimited string: 'item one,item two'
  items = items.split(',').map((item) => item.trim());
  const keys = [];
  items.reduce((r, n, i) => {
    if (array && array.length > 0) {
      array.map((elm, idx) => {
        if (n === elm) {
          keys.push(idx);
        }
      });
    }
  }, []);
  return keys.length > 0;
}

@customElement('awiol-header-nav')
export class AWIOLHeaderNav extends LitElement {
  @property({type: Object}) siteMap;
  @property({type: Object}) domainConfig;
  @property({type: Boolean}) logoLink;
  ID = getCookie('ID');
  login: any;
  roles: any;
  accountNumber = getCookie('accountNumber');
  perspectiveConfig = getObjectCookie('perspectiveConfig');
  sessionAccountNumber = sessionStorage.getItem('sessionAccountNumber');
  sessionSiteMap = JSON.parse(sessionStorage.getItem('sessionSiteMap'));
  configGroupId: any;
  // fill in the defaults if no service data
  appName: string;
  appLogo: string;
  appLink = '/';
  searchAction: string;
  cartAction: string;
  ordersAction: string;
  test: boolean;
  orderAdminRoles = 'ROLE_ORDER_ADMIN';
  orderScreenRoles = 'ROLE_SPECIAL_ORDER_PILOT,ROLE_CSG_COUNTER';
  cartRoles = 'ROLE_PS_INDEP_COUNTER';
  bigOrderButtonRoles = 'ROLE_CSG_COUNTER';
  hasCartRole = false;
  hasOrderAdminRole = false;
  hasOrderScreenRole = false;
  hasBigOrderButtonRole = false;

  constructor() {
    super();
  }

  protected firstUpdated(changedProperties: PropertyValues): void {
    this.setTypeAhead();
    super.firstUpdated(changedProperties);
  }

  static get properties() {
    return {
      siteMap: {
        type: Object
      }
    };
  }

  connectedCallback() {
    super.connectedCallback();
    // check if logged in
    if (this.ID) {
      // set default configGroupId
      this.configGroupId = this.domainConfig && this.domainConfig['configGroupId'] ? this.domainConfig['configGroupId'] : 162;
      // set default brand name
      this.appName = this.domainConfig && this.domainConfig['domainBrandName'] ? this.domainConfig['domainBrandName'] : '';
      // set default brand logo
      this.appLogo = this.domainConfig && this.domainConfig['defaultBrandLogo'] ? this.domainConfig['defaultBrandLogo'] : logoImage;
      // set default application link
      let applicationLink = this.domainConfig && this.domainConfig['domainUrl'] ? '//' + this.domainConfig['domainUrl'] : '/';
      // fix logo link for test and localhost
      if (typeof window !== 'undefined') {
        this.test = window.location.hostname.includes('localhost') || window.location.hostname.includes('test.sd');
        if (window.location.hostname === 'localhost' && applicationLink !== '/') {
          applicationLink = '/';
        }
      }
      this.appLink = applicationLink;
      // who are we?
      this.roles = jwtDecode<JwtPayload>(this.ID)['urn:json:security:roles'];
      this.login = jwtDecode<JwtPayload>(this.ID).iss;
      this.hasCartRole = getMultipleIndexes(this.cartRoles, this.roles);
      this.hasBigOrderButtonRole = getMultipleIndexes(this.bigOrderButtonRoles, this.roles);
      this.hasOrderAdminRole = getMultipleIndexes(this.orderAdminRoles, this.roles);
      this.hasOrderScreenRole = getMultipleIndexes(this.orderScreenRoles, this.roles);
      if (!this.accountNumber || !this.sessionAccountNumber || this.accountNumber !== this.sessionAccountNumber) {
        this.getMeData();
      }
      // no static sitemap
      if (!this.siteMap) {
        // no session sitemap
        if (!this.sessionSiteMap) {
          this.getHeaderData();
        } else {
          // does the sitemap id match the config id?
          if (!this.sessionSiteMap['id'] || this.configGroupId !== this.sessionSiteMap['id']) {
            sessionStorage.removeItem('sessionSiteMap');
            this.getHeaderData();
            // does the sitemap login match the current logged-in user?
          } else if (!this.sessionSiteMap['login'] || this.sessionSiteMap['login'] !== this.login) {
            sessionStorage.removeItem('sessionSiteMap');
            this.getHeaderData();
            // all good, set sitemap
          } else if (!this.sessionSiteMap['expiry']) {
            sessionStorage.removeItem('sessionSiteMap');
            this.getHeaderData();
          } else {
            // is the expiry time greater than now?
            if (new Date(this.sessionSiteMap['expiry']) > new Date()) {
              this.siteMap = this.sessionSiteMap;
              this.renderUpdate();
            } else {
              sessionStorage.removeItem('sessionSiteMap');
              this.getHeaderData();
            }
          }
        }
      } else {
        // using static sitemap and session exists, remove
        if (this.sessionSiteMap) {
          sessionStorage.removeItem('sessionSiteMap');
        }
      }
      this.searchAction = this.test ? 'https://ppsg.test.sd/search' : 'https://ppsg.autowaresgroup.com/search';
      this.cartAction = this.test ? 'https://ppsg.test.sd/cart' : 'https://ppsg.autowaresgroup.com/cart';
      this.ordersAction = this.test ? 'https://ppsg.test.sd/cart/redux' : 'https://ppsg.autowaresgroup.com/cart/redux';
    } else {
      const interceptor = new SecurityInterceptor();
      // remove all storage if not logged in
      if (this.sessionSiteMap) {
        sessionStorage.removeItem('sessionSiteMap');
      }
      // check for security redirect
      interceptor.checkForRedirect();
    }
  }

  // need this for numerous things like the cart
  getMeData() {
    axios.get('/ids/contact/me', {
      headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
      }
    })
      .then((res) => {
        const interceptor = new SecurityInterceptor(res);
        if (res && res['data'] && res['headers']['content-type'] !== 'text/html;charset=UTF-8') {
          if (res.data.userType) {
            interceptor.checkVendorLogin((callback) => {
              // this checks for vendor and redirects itself
              if (!callback) {
                if (res.data.accountNumber || res.data.accountNumber === 0) {
                  const cookie = this.perspectiveConfig && this.perspectiveConfig['accountNumber'] ? this.perspectiveConfig['accountNumber'] : res.data.accountNumber;
                  setCookie('accountNumber', cookie);
                  setCookie('awiol_login', res.data.userId);
                  if (this.hasOrderAdminRole) {
                    setCookie('ORDER_ADMIN', 'Y');
                  }
                  if (this.hasOrderScreenRole) {
                    setCookie('NEW_ORDER_SCREEN', 'Y');
                  }
                  sessionStorage.setItem('sessionAccountNumber', res.data.accountNumber);
                  sessionStorage.setItem('loggedInUser', JSON.stringify(res['data']));
                } else {
                  interceptor.checkForRedirect();
                }
              }
            });
          } else {
            if (res.data.accountNumber || res.data.accountNumber === 0) {
              const cookie = this.perspectiveConfig && this.perspectiveConfig['accountNumber'] ? this.perspectiveConfig['accountNumber'] : res.data.accountNumber;
              setCookie('accountNumber', cookie);
              setCookie('awiol_login', res.data.userId);
              if (this.hasOrderAdminRole) {
                setCookie('ORDER_ADMIN', 'Y');
              }
              if (this.hasOrderScreenRole) {
                setCookie('NEW_ORDER_SCREEN', 'Y');
              }
              sessionStorage.setItem('sessionAccountNumber', res.data.accountNumber);
              sessionStorage.setItem('loggedInUser', JSON.stringify(res['data']));
            } else {
              interceptor.checkForRedirect();
            }
          }
        } else {
          interceptor.checkForRedirect();
        }
      })
      .catch((error) => {
        console.error('error getting /ids/contact/me', error);
      });
  }

  renderUpdate() {
    this.requestUpdate('sessionSiteMap').then(() => {
      setTimeout(() => {
        this.initMmenu();
      }, 400);
    });
  }

  getHeaderData() {
    sessionStorage.removeItem('sessionSiteMap');
    this.siteMap = {
      id: null,
      login: null,
      items: []
    };
    axios.get('/cmsservice/client/' + this.configGroupId + '/navigation', {
      headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
      }
    })
      .then((res) => {
        const interceptor = new SecurityInterceptor(res);
        // for some reason the zuul router returns a 200 ok status on auth fail?
        if (res['data'] && res['headers']['content-type'] !== 'text/html;charset=UTF-8') {
          if (res && res['data'] && res['data']['items'] && res['data']['items'].length > 0) {
            this.siteMap['items'] = JSON.parse(JSON.stringify(res.data['items']));
            const id = res['data']['id'].split('-')[1];
            this.siteMap['id'] = +id;
            this.siteMap['login'] = jwtDecode<JwtPayload>(this.ID).iss;
            const dt = new Date();
            // expire session storage in four hours
            dt.setHours(dt.getHours() + 4);
            this.siteMap['expiry'] = dt;
            sessionStorage.setItem('sessionSiteMap', JSON.stringify(this.siteMap));
            this.renderUpdate();
          } else {
            interceptor.checkForRedirect();
          }
        } else {
          interceptor.checkForRedirect();
        }
      })
      .catch((error) => {
        console.error('error getting siteMap', error);
      });
  }

  refreshNavigation() {
    if (this.sessionSiteMap) {
      sessionStorage.clear();
    }
    setTimeout(() => {
      window.location.reload();
    }, 200);
  }

  handleLogOut() {
    deleteAllCookies((cb) => {
      if (cb) {
        this.unregisterServiceWorkers();
        sessionStorage.clear();
        setTimeout(() => {
          window.location.reload();
        }, 300);
      }
    });
  }

  initMmenu() {
    const panel = document.getElementById('awiol-sidenav');
    if (panel) {
      Mmenu.addons = {
        offcanvas,
        screenReader,
        scrollBugFix,
        counters,
        navbars,
        searchfield
      };
      // tslint:disable-next-line:no-unused-expression
      new Mmenu('#awiol-sidenav', {
        extensions: [
          'pagedim-black',
          'position-front'
        ],
        counters: true,
        navbars: [
          {
            position: 'top',
            content: [
              'searchfield',
              'close'
            ]
          },
          {
            position: 'top',
            content: [
              'prev',
              'breadcrumbs'
            ]
          }
        ],
        searchfield: {
          placeholder: 'Menu search',
          panel: true,
          showTextItems: true
        }
      }, {
        searchfield: {
          clear: true
        },
        offCanvas: {
          clone: false,
          page: {
            selector: '#offCanvasPage'
          }
        }
      });
    }
  }

  handleZendeskProperties() {
    axios.get('/ids/rest/zendesk/jwt/properties', {
      headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
      }
    })
      .then((res) => {
        if (res && res['data'] && res['headers']['content-type'] !== 'text/html;charset=UTF-8') {
          document.getElementById('jwtForm').setAttribute('action', res['data']['ssourl']);
          document.getElementById('jwtInput')['value'] = res['data']['zendeskJwtToken'];
          setTimeout(() => {
            document.forms['jwtForm'].submit();
          }, 300);
        } else {
          throw new Error('Error returning SSO Url');
        }
      })
      .catch((error) => {
        console.error('error getting zendesk properties', error);
      });
  }

  unregisterServiceWorkers() {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations()
        .then((registrations) => {
          return Promise.all(registrations.map((registration) => {
            return registration.unregister();
          }));
        });
    }
  }

  // render our typeahead
  setTypeAhead() {
    const inputEl = document.getElementById('search-terms');
    const spinner = document.getElementById('l-search-spinner');
    autocompleteTypeahead({
      input: inputEl,
      disableAutoSelect: true,
      preventSubmit: false,
      showOnFocus: true,
      minLength: 2,
      debounceWaitMs: 400,
      className: 'uk-list uk-list-divider',
      fetch: (text, update) => {
        if (text && text.length > 1) {
          spinner.setAttribute('style', 'display: block');
          const suggestions = [];
          let categories = [];
          let search = [];

          Promise.all([
            axios.get('/partservice/parts', {
              params: {
                page: 0,
                pageSize: 5,
                partNumber: text,
                priceFields: 'Core Price',
                customerNumber: getCookie('accountNumber'),
                visibleInViper: 'Y',
                fields: 'catalogReferences,supersededBy,images,price'
              }
            })
              .then((response) => {
                const supersede = [];
                search = response.data['contents'].filter((a) => {
                  a['group'] = 'Search Results';
                  if (a['supersededBy']) {
                    if (a['brandLogos'] && a['brandLogos'].length > 0 && a['brandLogos'][0]) {
                      a['supersededBy']['brandLogos'] = a['brandLogos'];
                    }
                    a['supersededBy']['group'] = 'Search Results';
                    supersede.push(JSON.parse(JSON.stringify(a['supersededBy'])));
                  }
                  return a['counterWorksLineCode'] + ' ' + a['partNumber'] + ' ' + a['partTitle'];
                });
                if (search.length > 0 || supersede.length > 0) {
                  suggestions.push(...[...new Set([...supersede, ...search])]);
                  update(suggestions);
                }
              })
              .catch((error) => {
                console.error(error);
              }),
            axios.get('/catalogv1/typeahead?query=' + text)
              .then((response) => {
                categories = response.data['terms'].filter((b) => {
                  b['group'] = 'Categories';
                  return b;
                });
                if (categories.length > 0) {
                  suggestions.push(...categories);
                  update(suggestions);
                }
              })
              .catch((error) => {
                console.error('error getting typeahead', error);
              })
          ])
            .then(() => {
              spinner.setAttribute('style', 'display: none');
              update(suggestions);
            });
        }
      },
      renderGroup: (groupName, currentValue) => {
        const p = document.createElement('p');
        p.className = 'autocomplete-list-group';
        p.textContent = groupName;
        return p;
      },
      render: (item, currentValue) => {
        const li = document.createElement('li');
        if (item['browseNode']) {
          li.className = 'autocomplete-list-item uk-padding-small';
          li.innerHTML = item['term'];
        } else {
          const supersede = item['supersededBy'] ? '<span class="uk-badge">Superseded - use ' + item['supersededBy']['counterWorksLineCode'] + ' ' + item['supersededBy']['partNumber'] + '</span><br>' : '';
          const brandLogo = item['brandLogos'] && item['brandLogos'].length > 0 && item['brandLogos'][0] ? '<img class="uk-responsive-width" src=' + item['brandLogos'][0] + ' data-src=' + item['brandLogos'][0] + ' width="55" height="55" alt="brand logo" uk-img>' : '';
          const thumbnail = item['thumbnailUrl'] && item['thumbnailUrl'].length > 0 && item['thumbnailUrl'][0] ? '<img class="uk-responsive-width" src=' + item['thumbnailUrl'][0] + ' data-src=' + item['thumbnailUrl'][0] + ' style="width: auto; height: 55px; alt="product image" uk-img>' : '';
          const itemImage = item['imageUrl'] && item['imageUrl'].length > 0 && item['imageUrl'][0] ? '<img class="uk-responsive-width" src=' + item['imageUrl'][0] + ' data-src=' + item['imageUrl'][0] + ' style="width: auto; height: 55px;" alt="product image" uk-img>' : '';
          const imageUrl = itemImage ? itemImage : brandLogo ? brandLogo : thumbnail ? thumbnail : '<div style="width: 55px; height: 55px"></div>';
          const size = item['size'] ? item['size'] : '';
          const price = item['price'] ? ' - $' + item['price'].toFixed(2) : item['jobberPrice'] ? ' - $' + item['jobberPrice'].toFixed(2) : '';
          const corePrice = item['corePrice'] ? ' ($' + item['corePrice'].toFixed(2) + ' core)' : '';
          li.className = 'autocomplete-list-item uk-padding-small';
          li.innerHTML = '<div class="uk-grid-collapse" uk-grid><div class="uk-width-1-4 uk-flex uk-flex-center" style="align-items: center">' + imageUrl + '</div><div class="uk-width-3-4" style="padding-left: 5px">' + supersede + item['brandLabel'] + ' ' + item['partTitle'] + ' ' + size + '<br>' + item['counterWorksLineCode'] + ' ' + item['partNumber'] + price + corePrice + '</div></div>';
        }
        return li;
      },
      onSelect: (event, item, input) => {
        // prevent the form from submitting
        event.preventDefault();
        if (item['browseNode']) {
          window.location.href = this.test ? 'https://ppsg.test.sd/' + item['browseNode'] : 'https://ppsg.autowaresgroup.com/' + item['browseNode'];
        } else {
          window.location.href = this.test ? 'https://ppsg.test.sd/' + item['catalogReferences'][0]['link'] : 'https://ppsg.autowaresgroup.com/' + item['catalogReferences'][0]['link'];
        }
      }
    });
  }

  render() {
    return html`
        <div id="offCanvasPage">
            <nav class="navbar-top-layer mmenu-fixed-header" uk-navbar>
                <div class="uk-navbar-left uk-flex-nowrap">
                    <!-- sidenav toggle -->
                    ${this.siteMap && this.siteMap.items && this.siteMap.items.length > 0 ?
                            html`<a href="#awiol-sidenav" class="navbar-menu" uk-navbar-toggle-icon></a>
                            <div id="awiol-sidenav">
                                <ul id="awiol-list">
                                    ${this.siteMap.items.filter((i) => i.assetLink && i.assetLink !== 'misc-menu-navigation').map((link) =>
                                            html`${link.children && link.children.length > 0 ?
                                                    html`
                                                        <li>
                                                            <span>${itemLabel(link)}</span>
                                                            <!-- children -->
                                                            <ul>
                                                                <!-- parent duplicate -->
                                                                ${link.children && link.children.length > 0 && link.children[0].title !== link.title ?
                                                                        html`
                                                                            <li>
                                                                                <a href=${fixRelativeLinks(link)}
                                                                                   target=${detectTarget(link)}>${itemLabel(link)}</a>
                                                                            </li>`
                                                                        : ''}
                                                                <!-- // end parent duplicate -->
                                                                ${link.children.map((child) =>
                                                                        html`${child.children && child.children.length > 0 ?
                                                                                html`
                                                                                    <li>
                                                                                        <span>${itemLabel(child)}</span>
                                                                                        <!-- grand children -->
                                                                                        <ul>
                                                                                            <!-- parent duplicate -->
                                                                                            ${child.children && child.children.length > 0 && child.children[0].title !== child.title ?
                                                                                                    html`
                                                                                                        <li>
                                                                                                            <a href=${fixRelativeLinks(child)}
                                                                                                               target=${detectTarget(child)}>${itemLabel(child)}</a>
                                                                                                        </li>`
                                                                                                    : ''}
                                                                                            <!-- // end parent duplicate -->
                                                                                            ${child.children.map((gc) =>
                                                                                                    html`
                                                                                                        ${gc.children && gc.children.length > 0 ?
                                                                                                                html`
                                                                                                                    <li>
                                                                                                                        <span>${itemLabel(gc)}</span>
                                                                                                                        <!-- great great grand children -->
                                                                                                                        <ul>
                                                                                                                            <!-- parent duplicate -->
                                                                                                                            ${gc.children && gc.children.length > 0 && gc.children[0].title !== gc.title ?
                                                                                                                                    html`
                                                                                                                                        <li>
                                                                                                                                            <a href=${fixRelativeLinks(gc)}
                                                                                                                                               target=${detectTarget(gc)}>${itemLabel(gc)}</a>
                                                                                                                                        </li>`
                                                                                                                                    : ''}
                                                                                                                            <!-- // end parent duplicate -->
                                                                                                                            ${gc.children.map((ggc) =>
                                                                                                                                    html`
                                                                                                                                        ${ggc.children && ggc.children.length > 0 ?
                                                                                                                                                html`
                                                                                                                                                    <li>
                                                                                                                                                        <span>${itemLabel(ggc)}</span>
                                                                                                                                                        <!-- great great great grand children -->
                                                                                                                                                        <ul>
                                                                                                                                                            <!-- parent duplicate -->
                                                                                                                                                            ${ggc.children && ggc.children.length > 0 && ggc.children[0].title !== ggc.title ?
                                                                                                                                                                    html`
                                                                                                                                                                        <li>
                                                                                                                                                                            <a href=${fixRelativeLinks(ggc)}
                                                                                                                                                                               target=${detectTarget(ggc)}>${itemLabel(ggc)}</a>
                                                                                                                                                                        </li>`
                                                                                                                                                                    : ''}
                                                                                                                                                            <!-- // end parent duplicate -->
                                                                                                                                                            ${ggc.children.map((gggc) =>
                                                                                                                                                                    html`
                                                                                                                                                                        ${gggc.children && gggc.children.length > 0 ?
                                                                                                                                                                                html`
                                                                                                                                                                                    <li>
                                                                                                                                                                                        <span>${itemLabel(gggc)}</span>
                                                                                                                                                                                        <!-- great great great great grand children -->
                                                                                                                                                                                        <ul>
                                                                                                                                                                                            <!-- parent duplicate -->
                                                                                                                                                                                            ${gggc.children && gggc.children.length > 0 && gggc.children[0].title !== gggc.title ?
                                                                                                                                                                                                    html`
                                                                                                                                                                                                        <li>
                                                                                                                                                                                                            <a href=${fixRelativeLinks(gggc)}
                                                                                                                                                                                                               target=${detectTarget(gggc)}>${itemLabel(gggc)}</a>
                                                                                                                                                                                                        </li>`
                                                                                                                                                                                                    : ''}
                                                                                                                                                                                            <!-- // end parent duplicate -->
                                                                                                                                                                                            ${gggc.children.map((ggggc) =>
                                                                                                                                                                                                    html`
                                                                                                                                                                                                        ${ggggc.children && ggggc.children.length > 0 ?
                                                                                                                                                                                                                html`
                                                                                                                                                                                                                    <li>
                                                                                                                                                                                                                        <a href=${fixRelativeLinks(ggggc)}
                                                                                                                                                                                                                           target=${detectTarget(ggggc)}>${itemLabel(ggggc)}</a>
                                                                                                                                                                                                                    </li>`
                                                                                                                                                                                                                : ''}`
                                                                                                                                                                                            )}
                                                                                                                                                                                        </ul>
                                                                                                                                                                                        <!-- // end great great great great grand children -->
                                                                                                                                                                                    </li>`
                                                                                                                                                                                : html`
                                                                                                                                                                                    <li>
                                                                                                                                                                                        <a href=${fixRelativeLinks(gggc)}
                                                                                                                                                                                           target=${detectTarget(gggc)}>${itemLabel(gggc)}</a>
                                                                                                                                                                                    </li>`}`
                                                                                                                                                            )}
                                                                                                                                                        </ul>
                                                                                                                                                        <!-- // end great great great grandchildren -->
                                                                                                                                                    </li>`
                                                                                                                                                : html`
                                                                                                                                                    <li>
                                                                                                                                                        <a href=${fixRelativeLinks(ggc)}
                                                                                                                                                           target=${detectTarget(ggc)}>${itemLabel(ggc)}</a>
                                                                                                                                                    </li>`}`
                                                                                                                            )}
                                                                                                                        </ul>
                                                                                                                        <!-- // end great great grand children -->
                                                                                                                    </li>`
                                                                                                                : html`
                                                                                                                    <li>
                                                                                                                        <a href=${fixRelativeLinks(gc)}
                                                                                                                           target=${detectTarget(gc)}>${itemLabel(gc)}</a>
                                                                                                                    </li>`}`
                                                                                            )}
                                                                                        </ul>
                                                                                        <!-- // end grand children -->
                                                                                    </li>`
                                                                                : html`
                                                                                    <li>
                                                                                        <a href=${fixRelativeLinks(child)}
                                                                                           target=${detectTarget(child)}>${itemLabel(child)}</a>
                                                                                    </li>`}`
                                                                )}
                                                            </ul>
                                                            <!-- // end children -->
                                                        </li>`
                                                    : html`
                                                        <li><a href=${fixRelativeLinks(link)}
                                                               target=${detectTarget(link)}>${itemLabel(link)}</a>
                                                        </li>`}`
                                    )}
                                    <!-- cart link -->
                                    ${this.hasCartRole && !this.hasBigOrderButtonRole ? html`
                                        <li class="uk-hidden@m">
                                            <a href=${this.cartAction}>
                                                Cart
                                            </a>
                                        </li>`
                                    : ''}
                                    <!-- orders link -->
                                    ${this.hasBigOrderButtonRole ? html`
                                        <li class="uk-hidden@m">
                                            <a href=${this.ordersAction}>
                                                Order Parts
                                            </a>
                                        </li>`
                                    : ''}
                                    <!-- account links -->
                                    <li class="uk-hidden@m">
                                        <span>Your Account</span>
                                        <ul>
                                            <li>
                                                <a href="/awi-manage-account/#/" target="_self">Manage Account</a>
                                            </li>
                                            <li>
                                                <a href="#" onclick="return false" @click="${this.refreshNavigation}">
                                                    Refresh Navigation
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" @click="${this.handleLogOut}" onclick="return false">Log Out</a>
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        <a href="#"
                                           onclick="return false"
                                           @click="${this.handleZendeskProperties}">
                                            HELP
                                        </a>
                                    </li>
                                </ul>
                            </div>`
                            : ''}
                    <!-- //end sidenav toggle -->
                    <!-- brand logo nd title -->
                    <a href=${this.logoLink ? this.appLink : 'https://www.autowaresgroup.com'}
                       class="uk-navbar-item uk-logo navbar-brand" target="_self">
                        ${this.test ?
                                html`<h1 class="uk-navbar-nav navbar-test">TEST SERVER</h1>`
                                :
                                html`<img data-src=${this.appLogo} src=${this.appLogo} alt="Brand image" uk-img>`
                        }
                    </a>
                    ${this.appName ?
                            html`<h1 class="uk-navbar-nav navbar-title">
                                <a href=${this.appLink} target="_self">${this.appName}</a>
                            </h1>`
                            : ''}
                    <!-- // end brand logo and title -->
                    <!-- navbar links -->
                    ${this.siteMap && this.siteMap.items && this.siteMap.items.length > 0 ?
                            html`
                                <ul class="uk-navbar-nav navbar-links uk-visible@m nav-overlay">
                                    ${this.siteMap.items.filter((i) => i.assetLink && i.assetLink !== 'misc-menu-navigation').map((link) =>
                                            html`
                                                <li>
                                                    ${link.children && link.children.length > 0 ?
                                                            html`<a class="main-nav-items"
                                                                    href="#">${itemLabel(link)}</a>`
                                                            :
                                                            html`<a class="main-nav-items"
                                                                    href=${fixRelativeLinks(link)}
                                                                    target=${detectTarget(link)}>${itemLabel(link)}</a>`
                                                    }
                                                    ${link.children && link.children.length > 0 ?
                                                            html`
                                                                <div class="uk-width-auto"
                                                                     uk-dropdown="animation: uk-animation-fade; delay-hide: 100">
                                                                    <div class="uk-dropdown-grid uk-child-width-auto"
                                                                         uk-grid>
                                                                        ${splitToChunks(link.children, 10).map((x) =>
                                                                                html`
                                                                                    <div>
                                                                                        <ul class="uk-nav uk-navbar-dropdown-nav">
                                                                                            ${x.map((child) => html`
                                                                                                <li>
                                                                                                    <a href=${fixRelativeLinks(child)}
                                                                                                       target=${detectTarget(child)}>
                                                                                                        ${itemLabel(child)}
                                                                                                    </a>
                                                                                                </li>`)}
                                                                                        </ul>
                                                                                    </div>`
                                                                        )}
                                                                    </div>
                                                                </div>`
                                                            : ''}
                                                </li>`
                                    )}
                                </ul>`
                            : ''}
                    <!-- // end navbar links -->
                </div>
                <!-- large search and nav with autocomplete -->
                <div class="uk-navbar-right uk-visible@l uk-flex-nowrap">
                    ${this.hasBigOrderButtonRole ? html`
                        <a href=${this.ordersAction}
                           uk-tooltip="Order parts"
                           style="margin-right: 0.5rem"
                           class="uk-button uk-button-default uk-button-small right-navbar-links search-overlay">
                          Order Parts
                        </a>`
                    : ''}
                    <div class="search-overlay">
                        <button type="button"
                                class="uk-navbar-toggle search-toggle"
                                uk-search-icon
                                uk-toggle="target: .search-overlay; animation: uk-animation-fade; delay-hide: 100"
                                uk-tooltip="Part search">
                            <i class="material-icons-outlined">search</i>
                        </button>
                    </div>
                    <div class="search-overlay uk-navbar-left uk-flex-1" hidden>
                        <div class="uk-navbar-item uk-width-expand uk-padding-remove-right">
                            <form class="uk-search uk-search-navbar uk-width-1-1"
                                  action=${this.searchAction}
                                  autocomplete="off"
                                  id="l-search-form">
                                <input class="uk-search-input uk-search-input-dark"
                                       id="search-terms"
                                       name="query"
                                       type="search"
                                       maxlength="100"
                                       minlength="2"
                                       placeholder="Part search"
                                       autofocus
                                       required>
                              <div id="l-search-spinner" uk-spinner class="uk-icon uk-spinner"></div>
                            </form>
                        </div>
                        <button type="button"
                                class="uk-navbar-toggle"
                                uk-close
                                style="color: #fff; height: 40px"
                                uk-toggle="target: .search-overlay; animation: uk-animation-fade; delay-hide: 100">
                        </button>
                    </div>
                    ${this.hasCartRole && !this.hasBigOrderButtonRole ? html`
                        <a href=${this.cartAction}
                           class="uk-button uk-button-link cart-nav-button uk-visible@m"
                           target="_self"
                           uk-tooltip="Order parts">
                            <i class="material-icons-outlined">shopping_cart</i>
                        </a>`
                    : ''}
                    <ul class="uk-iconnav misc-nav-menu">
                        <li>
                            <button class="uk-button uk-button-link three-dot-menu"
                                    uk-tooltip="Your account and settings"
                                    type="button">
                                <i class="material-icons-outlined" style="vertical-align: bottom">account_circle</i> ${this.login}
                            </button>
                            <div uk-dropdown="mode:click;offset:0;pos:bottom-right; animation: uk-animation-fade; delay-hide: 100">
                                <ul class="uk-nav uk-dropdown-nav">
                                    ${this.siteMap && this.siteMap.items && this.siteMap.items.length > 0 ?
                                            html`
                                                ${this.siteMap.items.filter((i) => i.children && i.children.length > 0 && i.assetLink && i.assetLink === 'misc-menu-navigation')[0] ?
                                                        html`
                                                            <li class="uk-nav-header">Misc Links</li>
                                                            ${this.siteMap.items.filter((i) => i.assetLink && i.assetLink === 'misc-menu-navigation')[0]['children'].map((link) =>
                                                                    html`
                                                                        <li>
                                                                            <a href=${fixRelativeLinks(link)}
                                                                               target=${detectTarget(link)}>
                                                                                ${itemLabel(link)}
                                                                            </a>
                                                                        </li>
                                                                    `
                                                            )}
                                                        `
                                                        : ''}
                                            `
                                            : ''}
                                    <li class="uk-nav-header">Your Account</li>
                                    <li>
                                        <a href="/awi-manage-account/#/" target="_self">Manage Account</a>
                                    </li>
                                    <li>
                                        <a href="#" @click="${this.refreshNavigation}" onclick="return false">
                                            Refresh Navigation
                                        </a>
                                    </li>
                                    <li class="uk-nav-divider"></li>
                                    <li>
                                      <a href="#" @click="${this.handleLogOut}" onclick="return false">Log Out</a>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
                <!-- small search and nav with dropdown search -->
                <div class="uk-navbar-right uk-hidden@l">
                    ${this.hasBigOrderButtonRole ? html`
                        <a href=${this.ordersAction}
                           uk-tooltip="Order parts"
                           style="margin-right: 0.5rem"
                           class="uk-button uk-button-default uk-button-small right-navbar-links uk-visible@m">
                          Order Parts
                        </a>`
                    : ''}
                    <div>
                        <button type="button"
                                class="uk-navbar-toggle search-toggle uk-padding-remove"
                                uk-search-icon
                                uk-tooltip="Part search">
                            <i class="material-icons-outlined">search</i>
                        </button>
                        <div class="uk-navbar-dropdown uk-padding-small"
                             uk-drop="mode: click; cls-drop: uk-navbar-dropdown; boundary: !.uk-navbar; flip: false; shift: false; pos: bottom-right">

                            <div class="uk-grid-small uk-flex-middle" uk-grid>
                                <div class="uk-width-expand">
                                    <form class="uk-search uk-search-navbar uk-width-medium"
                                          action=${this.searchAction}
                                          autocomplete="off">
                                        <input class="uk-search-input"
                                               id="mobile-terms"
                                               name="query"
                                               type="search"
                                               maxlength="100"
                                               minlength="2"
                                               placeholder="Part search"
                                               required>
                                    </form>
                                </div>
                                <div class="uk-width-auto">
                                    <button type="button" class="uk-drop-close" uk-close></button>
                                </div>
                            </div>

                        </div>
                    </div>
                    ${this.hasCartRole && !this.bigOrderButtonRoles ? html`
                        <a href=${this.cartAction}
                           class="uk-button uk-button-link cart-nav-button uk-visible@m"
                           target="_self"
                           uk-tooltip="Order parts">
                            <i class="material-icons-outlined">shopping_cart</i>
                        </a>`
                    : ''}
                    <ul class="uk-iconnav misc-nav-menu pl-2 uk-visible@m">
                        <li>
                            <button class="uk-button uk-button-link three-dot-menu"
                                    type="button"
                                    uk-tooltip="Your account and settings">
                                <i class="material-icons-outlined" style="vertical-align: bottom">account_circle</i> ${this.login}
                            </button>
                            <div uk-dropdown="mode:click;offset:0;pos:bottom-right; animation: uk-animation-fade; delay-hide: 100">
                                <ul class="uk-nav uk-dropdown-nav">
                                    ${this.siteMap && this.siteMap.items && this.siteMap.items.length > 0 ?
                                            html`
                                                ${this.siteMap.items.filter((i) => i.children && i.children.length > 0 && i.assetLink && i.assetLink === 'misc-menu-navigation')[0] ?
                                                        html`
                                                            <li class="uk-nav-header">Misc Links</li>
                                                            ${this.siteMap.items.filter((i) => i.assetLink && i.assetLink === 'misc-menu-navigation')[0]['children'].map((link) =>
                                                                    html`
                                                                        <li>
                                                                            <a href=${fixRelativeLinks(link)}
                                                                               target=${detectTarget(link)}>
                                                                                ${itemLabel(link)}
                                                                            </a>
                                                                        </li>
                                                                    `
                                                            )}
                                                        `
                                                        : ''}
                                            `
                                            : ''}
                                    <li class="uk-nav-header">Your Account</li>
                                    <li>
                                        <a href="/awi-manage-account/#/" target="_blank">Manage Account</a>
                                    </li>
                                    <li>
                                        <a href="#" @click="${this.refreshNavigation}" onclick="return false">
                                            Refresh Navigation
                                        </a>
                                    </li>
                                    <li class="uk-nav-divider"></li>
                                    <li>
                                        <a href="#" @click="${this.handleLogOut}" onclick="return false">Log Out</a>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="uk-navbar-item uk-visible@m uk-padding-remove help-nav-button">
                    <a href="#"
                       onclick="return false"
                       class="uk-button uk-button-default uk-button-small right-navbar-links"
                       @click="${this.handleZendeskProperties}"
                       uk-tooltip="Auto-Wares Support">
                        Help
                    </a>
                </div>
            </nav>
        </div>
        <form id="jwtForm" method="post" action="" target="_blank" style="visibility: hidden">
            <input id="jwtInput" type="hidden" name="jwt" />
        </form>
    `;
  }

  // access to shadow dom
  createRenderRoot() {
    return this;
  }
}
